export const CREATE_SHIPMENTS_USER_PERMISSION = 'shipments.create_shipments';
export const CREATE_ORDERS_USER_PERMISSION = 'orders.create_orders';
export const CREATE_QUOTES_USER_PERMISSION = 'quotes.create_quotes';
export const VIEW_SHIPMENT_FINANCIALS_USER_PERMISSION = 'shipments.view_financials';
export const VIEW_ADDRESS_BOOK_PERMISSION = 'locations.view_address_book_entries';
export const CREATE_ADDRESS_BOOK_PERMISSION = 'locations.create_address_book_entries';
export const UPDATE_ADDRESS_BOOK_PERMISSION = 'locations.update_address_book_entries';
export const DELETE_ADDRESS_BOOK_PERMISSION = 'locations.delete_address_book_entries';
